"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkFor = exports.getWeddingStoreAccountSettingsNav = exports.getBabyStoreAccountSettingsNav = exports.getAccountSettingsNav = exports.getAccountSettingNavForStore = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _insertInArrayIf = _interopRequireDefault(require("./insertInArrayIf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var BABY_ACCOUNT_SETTINGS_PAGES = ['details', 'registries'];
var WEDDING_ACCOUNT_SETTINGS_PAGES = ['hellos-from-vendors', 'wedding', 'privacy', 'notifications', 'other-registries', 'urls'];
var COMMON_ACCOUNT_SETTINGS_PAGES = ['bank', 'cash', 'credits', 'info', 'invitepartner', 'orders', 'password-security', 'reviews', 'shipping'];

/**
 * All possible partial paths to account settings pages.  The full URL can be
 * constructed from the slug by prefixing `/account/settings/`.
 */

var NON_ACCOUNT_SETTINGS_PAGES = ['invite-friends'];

/**
 * Non-account settings pages that do not follow slug prefix `/account/settings/`.
 */

var isNonAccountSettingsPage = function isNonAccountSettingsPage(page) {
  return NON_ACCOUNT_SETTINGS_PAGES.includes(page);
};
var NON_ACCOUNT_SETTINGS_PAGE_URLS = {
  'invite-friends': '/wedding-registry/invite'
};

/**
 * A link to an account settings page within a section.
 */

/**
 * A section, for desktop, appearing in a left rail, with a Heading and a list
 * of user-specific links to other settings pages.
 */

/**
 * Helper to generate a AccountSettingsLink from the slug/text and to set the
 * active flag based on the current page.
 *
 * @param slug
 * @param text
 * @param currentPage
 *
 * @returns AccountSettingsLink
 */
var linkFor = exports.linkFor = function linkFor(slug, text, currentPage) {
  if (isNonAccountSettingsPage(slug)) {
    return {
      slug: slug,
      text: text,
      active: false,
      href: NON_ACCOUNT_SETTINGS_PAGE_URLS[slug]
    };
  }

  // AccountSettingsPage
  return {
    slug: slug,
    text: text,
    active: slug === currentPage,
    href: "/account/settings/".concat(slug)
  };
};

/**
 * Gets the meta-data for the account settings nav.  Returns an ordered set of
 * sections, each with a heading and number of links.  The sections are user
 * specific.
 *
 * @param userContext
 * @param featureFlags When you need a feature flagged account link add it as an
 * optional indexed string here then set the flag from the client
 *
 * https://github.com/NewAmsterdamLabs/zola-helpers/pull/222/files#diff-507a53cd596542e43d6c5be92daf71b1be0a45cff5d1de46840d81b3240ec32cR90-R92
 * ```typescript
 *   featureFlags?: { 'invites-from-vendors'?: boolean; }
 * ```
 *
 * https://github.com/NewAmsterdamLabs/web-registry/commit/16d4f94f01785b95ab52d3b422ceb80c0d9a3218#diff-058476176f5598d5d09414b07b301803777ee44bdbbcba78af0d0d4711cb7885R21-R23
 * ```typescript
 * const accountMenu = getWeddingStoreAccountSettingsNav(userContext as UserContext, page, {
 *   'invites-from-vendors': featureFlags.get('invitesFromVendors'),
 * });
 *
 * @param currentPage
 * @returns
 */
var getWeddingStoreAccountSettingsNav = exports.getWeddingStoreAccountSettingsNav = function getWeddingStoreAccountSettingsNav(userContext, currentPage, featureFlags) {
  var isAccountOwner = (0, _get2.default)(userContext, 'user_role_account_weddings[0].role', null) === 'OWNER';
  var hasRegistryAccount = Boolean(userContext.has_registry);
  var hasWeddingAccount = Boolean(userContext.has_wedding_account);
  var hasCompletedOnboarding = Boolean(userContext.has_completed_onboarding);
  var hasMarketplaceAccount = Boolean(userContext.has_marketplace_account);
  var sections = [];
  var accountSection = {
    heading: 'Your account',
    links: [linkFor('info', 'Information', currentPage), linkFor('orders', "Orders you've placed", currentPage), linkFor('reviews', 'Ratings and reviews', currentPage), linkFor('credits', 'Zola store credit', currentPage), linkFor('notifications', 'Email preferences', currentPage), linkFor('password-security', 'Password and security', currentPage)].concat(_toConsumableArray((0, _insertInArrayIf.default)(hasMarketplaceAccount, linkFor('hellos-from-vendors', 'Hellos from vendors', currentPage))), [linkFor('invite-friends', 'Invite friends', currentPage)])
  };
  sections.push(accountSection);
  if (hasCompletedOnboarding) {
    var weddingSection = {
      heading: 'Your wedding',
      links: [linkFor('wedding', 'Your wedding details', currentPage)]
    };
    if (isAccountOwner && (hasWeddingAccount || hasRegistryAccount)) {
      weddingSection.links.push(linkFor('invitepartner', 'Invite a partner', currentPage));
    }
    if (hasRegistryAccount) {
      weddingSection.links.push(linkFor('shipping', 'Registry shipping address', currentPage));
      weddingSection.links.push(linkFor('bank', 'Bank account info', currentPage));
      weddingSection.links.push(linkFor('cash', 'Cash fund fee', currentPage));
      weddingSection.links.push(linkFor('other-registries', 'Other registries', currentPage));
    }
    sections.push(weddingSection);
    if (hasRegistryAccount || hasWeddingAccount) {
      sections.push({
        heading: 'Your settings',
        links: [linkFor('urls', 'URLs', currentPage), linkFor('privacy', 'Privacy settings', currentPage)]
      });
    }
  }
  return sections;
};

/** @deprecated use getWeddingStoreAccountSettingsNav or getAccountSettingNavForStore */
var getAccountSettingsNav = exports.getAccountSettingsNav = getWeddingStoreAccountSettingsNav;
var getBabyStoreAccountSettingsNav = exports.getBabyStoreAccountSettingsNav = function getBabyStoreAccountSettingsNav(userContext, currentPage, featureFlags) {
  var sections = [{
    heading: 'Your account',
    links: [linkFor('info', 'Information', currentPage), linkFor('password-security', 'Password and security', currentPage), linkFor('details', 'Your details', currentPage), linkFor('invitepartner', 'Invite collaborator', currentPage), linkFor('credits', 'Zola credits', currentPage)]
  }, {
    heading: 'Registry settings',
    links: [linkFor('privacy', 'Privacy settings', currentPage), linkFor('shipping', 'Shipping address', currentPage), linkFor('bank', 'Bank account info', currentPage), linkFor('cash', 'Cash fund settings', currentPage), linkFor('registries', 'Switch registries', currentPage)]
  }, {
    heading: 'Your orders',
    links: [linkFor('orders', 'Order history', currentPage), linkFor('reviews', 'Ratings and reviews', currentPage)]
  }];
  return sections;
};
var getAccountSettingNavForStore = exports.getAccountSettingNavForStore = function getAccountSettingNavForStore(userContext, store, currentPage, featureFlags) {
  if (store === 'BABY_REGISTRY') {
    return getBabyStoreAccountSettingsNav(userContext, currentPage, featureFlags);
  }
  return getWeddingStoreAccountSettingsNav(userContext, currentPage, featureFlags);
};